import { c as _c } from "react/compiler-runtime";
import { getEntry } from "@/lib/contentful/guards";
import { useProductBuilderContext } from "./ProductBuilderContext";
export function useProductMicrocopy() {
  const $ = _c(2);
  const {
    product
  } = useProductBuilderContext();
  let t0;
  if ($[0] !== product.microcopy) {
    t0 = getEntry(product.microcopy)?.fields;
    $[0] = product.microcopy;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}